import { Box } from "@mui/material";
import { Button } from "@samdesk/components/Button";
import { Heading } from "@samdesk/components/Heading";
import { wrapperSx } from "router/authStyles";

import AccountButton from "./AccountButton";
import useController from "./useController";

const Index = () => {
	const { handleAccountSelect, handleSignout, person } = useController();

	return (
		<Box sx={columnSx}>
			<Heading level="1">Choose an account</Heading>
			<Box sx={accountListSx}>
				{person?.partialAccounts.map((partialAccount) => {
					return (
						<AccountButton
							key={partialAccount._id}
							name={person?.name}
							onClick={(e) => handleAccountSelect(e, partialAccount)}
							partialAccount={partialAccount}
						/>
					);
				})}
			</Box>
			<Box sx={signOutSx}>
				<Button label="Sign out" onClick={handleSignout} />
			</Box>
		</Box>
	);
};

export default Index;

/** Style */

const columnSx = {
	...wrapperSx,
	alignItems: "flex-start",
	display: "flex",
	flexDirection: "column",
	gap: "var(--space-base)",
	maxHeight: "100%",
};

const signOutSx = {
	flexShrink: 0,
};

const accountListSx = {
	maxWidth: "300px",
	minHeight: 0,
	overflowY: "auto",
	width: "100%",
};
